import { Box, Button, Dialog, Spinner } from '@veracity/vui'
import { useState } from 'react'
import { useForm } from 'react-hook-form'

import { InputFormControl, SelectFormControl } from '@/components'
import { PricePlanSimple } from '@/interfaces'

import { useOrganizations } from '../../hooks'

interface Props {
  availablePricePlans: PricePlanSimple[]
}

interface FormValues {
  name: string
  description: string
  pricePlanId: number
  expirationDate: Date
}

export const AddOrganizationDialog = ({ availablePricePlans }: Props) => {
  const [isOpen, setIsOpen] = useState(false)
  const { addOrganization, isAddOrganizationInProgress } = useOrganizations()

  const { control, handleSubmit, reset } = useForm<FormValues>()

  const handleSubmitClick = (formValues: FormValues) => {
    addOrganization(
      {
        name: formValues.name,
        description: formValues.description,
        pricePlanId: formValues.pricePlanId,
        expirationDate: formValues.expirationDate
      },
      { onSuccess: handleCloseClick }
    )
  }

  const handleCloseClick = () => {
    if (!isAddOrganizationInProgress) {
      reset()
      setIsOpen(false)
    }
  }

  return (
    <>
      <Button size="lg" iconLeft="falPlus" onClick={() => setIsOpen(true)}>
        Add Organization
      </Button>

      <Dialog
        isOpen={isOpen}
        size="lg"
        title="Add Organization"
        onClose={handleCloseClick}
        cancelButton={{ text: 'Cancel', disabled: isAddOrganizationInProgress }}
        submitButton={{
          text: 'Add',
          onClick: handleSubmit(handleSubmitClick),
          isLoading: isAddOrganizationInProgress,
          disabled: isAddOrganizationInProgress
        }}
        body={
          isAddOrganizationInProgress ? (
            <Box column p={2}>
              <Spinner />
            </Box>
          ) : (
            <Box column p={2} gap={2}>
              <InputFormControl
                control={control}
                formControlName="name"
                label="Name"
                size="md"
                rules={{ required: true }}
              />
              <InputFormControl
                control={control}
                formControlName="description"
                label="Description"
                size="md"
              />

              <SelectFormControl
                control={control}
                formControlName="pricePlanId"
                label="Price Plan"
                size="md"
                rules={{ required: true }}
                options={availablePricePlans.map(x => ({
                  text: x.name || '',
                  value: x.id
                }))}
              />

              <InputFormControl
                control={control}
                formControlName="expirationDate"
                size="md"
                type="date"
                label="Expiration Date"
                rules={{ required: true }}
              />
            </Box>
          )
        }
      />
    </>
  )
}
